import $ from 'jquery';
import Keyboard from './keyboard';
/*

Creates no focus on click events, but focuses when tabs

*/
export const HTML = 'html';
export const NO_FOCUS = 'no-focus';
export const FOCUS_ACTIVE = 'focus-active';
/**
 * Tab Event
 * @param  {jQuery} $html - html element
 * @param  {event} evt - key event
 */
const tabEventHandler = (evt) => {
  if (Keyboard.parseKey(evt) === 'TAB' || Keyboard.parseKey(evt) === 'SHIFT_TAB') {
    $(HTML).removeClass(NO_FOCUS);
    $(HTML).addClass(FOCUS_ACTIVE);
  }
};

const clickEventHandler = () => {
  $(HTML).addClass(NO_FOCUS);
  $(HTML).removeClass(FOCUS_ACTIVE);
};

const noFocus = () => {
  $(HTML).addClass(NO_FOCUS);
  $(HTML).on('mousedown.noFocus', evt => clickEventHandler(evt));
  $(HTML).on('keyup.noFocus', evt => tabEventHandler(evt));
};

export default noFocus;



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/no-focus.js